import {
  init,
  browserTracingIntegration,
  captureConsoleIntegration,
} from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

const tracesSampleRate = parseInt(
  process.env.SENTRY_TRACES_SAMPLE_RATE || "0.01",
  10,
);

init({
  dsn: "https://3c7213e8ae31fa0f8e749c156fb863e6@o4509871047835648.ingest.de.sentry.io/4509960160870480",
  tracesSampleRate,
  enableLogs: true,

  integrations: [
    captureConsoleIntegration({ levels: ["error"] }),
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    // Uncomment below to enable replay sessions and errors
    // replayIntegration({
    //   maskAllText: true,
    //   blockAllMedia: true,
    // }),
  ],

  // Uncomment below to enable replay sessions and errors
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1,
});

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
